import { render, staticRenderFns } from "./BattleBracketsEditor.vue?vue&type=template&id=556be093&scoped=true"
import script from "./BattleBracketsEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./BattleBracketsEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BattleBracketsEditor.vue?vue&type=style&index=0&id=556be093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556be093",
  null
  
)

export default component.exports